import { FC, ReactNode } from 'react';
import { components, ContainerProps } from 'react-select';
import styled from 'styled-components';
import SelectedValuesContainer from '../SelectedValuesContainer';

const SelectContainer: FC<ContainerProps> = ({
  children,
  className,
  innerProps,
  isFocused,
  ...commonProps
}) => {
  return (
    <Root>
      <components.SelectContainer
        className={className}
        innerProps={innerProps}
        isFocused={isFocused}
        {...commonProps}
      >
        {children}
        {commonProps.isMulti && (
          <StyledSelectedValuesContainer {...commonProps}>
            {{} as ReactNode}
          </StyledSelectedValuesContainer>
        )}
      </components.SelectContainer>
    </Root>
  );
};

export default SelectContainer;

const Root = styled.div``;

const StyledSelectedValuesContainer = styled(SelectedValuesContainer)`
  margin-top: 8px;
`;
